import { Formik } from 'formik';
import ErrorMessage from '../../../form/ErrorMessage';
import { addEditProjectSchema } from '../../../../utils/schema';
import TagInput from '../../../form/TagInput';
import { useDispatch } from 'react-redux';

const AddEditProject = ({ onClose, handleEditAddroject, isAdmin }) => {
  const initialValues = {
    project_categories: [], //
    budget: "", //
    start_date: "", //
    project_description: "", //
    project_title: "", //
    role_in_project: "", //
    team_member_required: "", //
    // project_categories: "",
    project_duration: "", //
    availability: "",
    duration_type: "month", //
    status: isAdmin ? "inreview" : "pending"
  };

  const projectDurationOptions = [
    "Less than 1 month",
    "1–3 months",
    "3–6 months",
    "6+ months",
  ];

  const availabilityOptions = [
    { label: "Remote Freelance", value: "Remote Freelance" },
    { label: "Full-time Freelance", value: "Full-time Freelance" },
    { label: "Part-time Freelance", value: "Part-time Freelance" },
    { label: "Hybrid Freelance", value: "Hybrid Freelance" },
    { label: "On-Site Freelance", value: "On-Site Freelance" },
    { label: "Project-Based", value: "Project Based" },
  ];

  const handleAddUpdateProject = (values) => {
    handleEditAddroject(values);
  };

  return (
    <div
      className="modal d-block ct_congratulation_modal_fade ct_reactivate_account"
      tabIndex="-1"
    >
      <div
        class="modal-dialog modal-dialog-centered ct_modal-dialog"
        style={{ maxWidth: "600px" }}
      >
        <div class="modal-content ct_p_30 ct_border_radius_20">
          <div class="modal-header border-0 p-0 ct_mb_30">
            <div>
              <h4 class="mb-1 ct_fs_20">Add New Project</h4>
            </div>
            <button
              type="button"
              class="btn-close ct_circle_close"
              aria-label="Close"
              onClick={onClose}
            ></button>
          </div>
          <div class="modal-body p-0">
            <Formik
              initialValues={initialValues}
              validationSchema={addEditProjectSchema}
              onSubmit={(values, actions) => {
                handleAddUpdateProject(values);
              }}
              enableReinitialize
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setTouched,
              }) => (
                <form className="ct_modal_scroll ct_custom_scroll px-4 pb-3 ">
                  <div className="row">
                    <div className="col-md-12">
                      <div class="form-group ct_mb_20">
                        <label class="ct_fs_14 ct_darkblue_text mb-2">
                          Project Title
                        </label>
                        <input
                          type="text"
                          id="project_title"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.project_title}
                          placeholder="Project Title"
                          className="form-control ct_input ct_fs_12"
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"project_title"}
                        />
                      </div>
                      <div class="form-group ct_mb_20">
                        <label class="ct_fs_14 ct_darkblue_text mb-2">
                          Role in Project
                        </label>
                        <input
                          type="text"
                          id="role_in_project"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.role_in_project}
                          placeholder="Enter Role in Project"
                          className="form-control ct_input ct_fs_12"
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"role_in_project"}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div class="form-group ct_mb_20">
                          <label class="ct_fs_14 ct_darkblue_text mb-2">
                            Start Date
                          </label>
                          <input
                            type="date"
                            id="start_date"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values?.start_date}
                            min={new Date().toISOString().split("T")[0]}
                            className="form-control ct_input ct_fs_12"
                          />
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName={"start_date"}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div class="form-group ct_mb_20">
                          <label class="ct_fs_14 ct_darkblue_text mb-2">
                            Team Member
                          </label>
                          <input
                            type="number"
                            id="team_member_required"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values?.team_member_required}
                            placeholder="Enter Team Member"
                            className="form-control ct_input ct_fs_12"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => {
                              if (
                                e.key === "ArrowUp" ||
                                e.key === "ArrowDown"
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName={"team_member_required"}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div class="form-group ct_mb_20">
                          <label class="ct_fs_14 ct_darkblue_text mb-2">
                            Budget
                          </label>
                          <input
                            type="text"
                            id="budget"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values?.budget}
                            placeholder="Enter Budget"
                            className="form-control ct_input ct_fs_12"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => {
                              if (
                                e.key === "ArrowUp" ||
                                e.key === "ArrowDown"
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName={"budget"}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div class="form-group ct_mb_20">
                          <label class="ct_fs_14 ct_darkblue_text mb-2">
                            Estimated Project Duration
                          </label>
                          <div className="d-flex flex-column gap-2 position-relative">
                            <select
                              className="form-control ct_input"
                              id="project_duration"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.project_duration}
                            >
                              <option value="">Select Duration</option>
                              {projectDurationOptions.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                          </div>
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName={"project_duration"}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div class="form-group ct_mb_20">
                          <label class="ct_fs_14 ct_darkblue_text mb-2">
                            Availability
                          </label>
                          <div className="d-flex flex-column gap-2 position-relative">
                            <select
                              className="form-control ct_input"
                              id="availability"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.availability}
                            >
                              <option value="">Select Availability</option>
                              {availabilityOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                          </div>
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName={"availability"}
                          />
                        </div>
                      </div>
                      <TagInput
                        label="Skills"
                        placeholder="Type to add skills..."
                        name="project_categories"
                        value={values.project_categories}
                        onChange={setFieldValue}
                        error={
                          touched.project_categories &&
                          errors.project_categories
                        }
                      />
                      <div className="col-md-12">
                        <div class="form-group ct_mb_20">
                          <label class="ct_fs_14 ct_darkblue_text mb-2">
                            Project Description
                          </label>
                          <textarea
                            class="form-control ct_input h-auto ct_fs_12"
                            rows={4}
                            id="project_description"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values?.project_description}
                            placeholder="Enter Project Description"
                          />
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName={"project_description"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-3 justify-content-end ">
                    <button
                      class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44"
                      type="button"
                      onClick={onClose}
                    >
                      Cancel
                    </button>
                    <button
                      class="ct_yellow_btn px-5 ct_h_44"
                      onClick={handleSubmit}
                      type="button"
                    >
                      Continue
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEditProject;
